/**
 * El resultado de una campaña en corto, para su tarjeta en Campañas y en Inicio (diseño `Campanas.dc.html` y
 * `Main.dc.html`): cuándo salió y cuántos grupos, cómo le fue a cada uno en el envío y los cuatro números (recibieron,
 * compraron, facturaron y vendiste de más, que sin firmeza es «≈ $0»).
 */

import { nombreDelGrupo } from "../../segmentaciones/logic/segmentar";
import type { GrupoDeLaSegmentacion } from "../../segmentaciones/types";
import { cifrasDeLaCampana, salidaDelGrupo, textoSalida } from "../logic/resultado";
import type { ResumenDelResultado } from "../types";

export function ResultadoEnCorto({ resultado, grupos }: { resultado: ResumenDelResultado; grupos: GrupoDeLaSegmentacion[] }) {
  return (
    <div className="space-y-3" data-testid="resultado-en-corto">
      <p className="text-sm text-slate-500">{textoSalida(resultado, grupos.length)}</p>
      {grupos.length > 0 && (
        <span className="flex flex-wrap gap-2 text-sm">
          {grupos.map((g, i) => {
            const salida = salidaDelGrupo(resultado.grupos.find((x) => x.id === g.id));
            return (
              <span key={g.id} className={`rounded-full px-2.5 py-1 ${salida === "no salió" ? "bg-slate-100 text-slate-500" : "bg-violet-50 text-violet-800"}`}>
                {nombreDelGrupo(g, i)} · {salida}
              </span>
            );
          })}
        </span>
      )}
      <dl className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        {cifrasDeLaCampana(resultado).map((c) => (
          <div key={c.titulo} className="rounded-xl bg-slate-50 px-3 py-2.5">
            <dt className="text-xs text-slate-500">{c.titulo}</dt>
            <dd className="text-lg font-bold text-slate-900">{c.valor}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
